import { Component, inject, Input } from '@angular/core';
import { DisplayableSelectedAttributes } from 'src/app/interfaces/displayable-selected-attributes';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent {
  @Input() selectedAttributes: Map<string, string | null> | null = null;

  keysToAlwaysShow = ['Design', 'Profile', 'Material', 'Width', 'Features', 'Size'];

  displayableSelectedAttributes: DisplayableSelectedAttributes[] = [];
  ngOnInit() {
    this.displayableSelectedAttributes = Array.from(new Set(Array.from(this.keysToAlwaysShow.concat(Array.from(this.selectedAttributes?.keys() ?? []))))).reduce((attrs, key) => {
      const [mainAttribute, subAttribute] = key.split('.');
      const selectedAttribute = this.selectedAttributes?.get(key)?.split('.')?.pop();

      if (selectedAttribute || this.keysToAlwaysShow.includes(mainAttribute)) {
        let matchingMainAttribute = attrs.find(attr => attr.name === mainAttribute);

        if (!matchingMainAttribute) {
          matchingMainAttribute = {
            name: mainAttribute,
            value: selectedAttribute ?? 'None'
          };

          attrs.push(matchingMainAttribute);
        }

        if (subAttribute) {
          matchingMainAttribute.value = null;
          matchingMainAttribute.children = (matchingMainAttribute.children ?? []).concat([{ name: subAttribute, value: selectedAttribute ?? 'None' }]);
        }
      }
      return attrs;
    }, [] as DisplayableSelectedAttributes[]);
  }
}
